import { useParams } from 'react-router-dom'
import { Box } from '@mantine/core'

import { AdvisorAccountsShell } from '@/modules/advisors/users/pages/[id]/components/AdvisorAccountsShell/AdvisorAccountsShell'
import { UserInfoHeader } from '@/modules/advisors/users/pages/[id]/components/UserInfoHeader/UserInfoHeader'

import { Loader } from '@/components/Loader/Loader'
import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

import {
  useAdvisorsServiceAdvisorUsersControllerGetAccounts,
  useAdvisorsServiceAdvisorUsersControllerGetUserById,
} from '@/__generated__/queries'

export function Component() {
  const { id: userId } = useParams<{ id: string }>()
  const numericUserId = userId ? +userId : 0

  const { data: user } = useAdvisorsServiceAdvisorUsersControllerGetUserById({
    userId: numericUserId,
  })

  const {
    data: accountsData,
    isFetching,
    isLoading,
  } = useAdvisorsServiceAdvisorUsersControllerGetAccounts({
    userId: numericUserId,
  })

  const accounts = accountsData?.accounts ?? []

  if (!user) return null

  const isLoadingAccounts = isLoading || isFetching

  let content

  if (isLoadingAccounts) {
    content = <Loader isMinimized />
  } else if (accounts.length) {
    content = <AdvisorAccountsShell accounts={accounts} />
  } else {
    content = (
      <Text variant="body_4_gray">This user has no connected accounts.</Text>
    )
  }

  return (
    <Box>
      <UserInfoHeader user={user} userId={userId ?? ''} />

      <Title mb={16} variant="h1">
        Accounts
      </Title>

      {content}
    </Box>
  )
}

Component.displayName = 'UserAccounts'
